import { render } from "./ServeProcess.vue?vue&type=template&id=f096f6bc&scoped=true"
import script from "./ServeProcess.vue?vue&type=script&lang=ts"
export * from "./ServeProcess.vue?vue&type=script&lang=ts"

import "./ServeProcess.vue?vue&type=style&index=0&id=f096f6bc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f096f6bc"

export default script